/* Native disclosures work without JavaScript; enhancements add keyboard dismissal and header sizing. */
(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-cm-header]').forEach(header => {
      if (header.dataset.cmReady) return;
      header.dataset.cmReady = 'true';
      const disclosures = [...header.querySelectorAll('[data-cm-disclosure]')];
      const resize = () => {
        document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
        document.body.style.setProperty('--header-group-height', `${header.closest('#header-group')?.offsetHeight || header.offsetHeight}px`);
      };
      resize();
      const observer = new ResizeObserver(resize);
      observer.observe(header);
      const group = header.closest('.shopify-section');
      const onUnload = event => {
        if (event.target === group || event.target.contains(header)) {
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', onUnload);
        }
      };
      document.addEventListener('shopify:section:unload', onUnload);
      disclosures.forEach(details => details.addEventListener('toggle', () => {
        if (details.open) disclosures.forEach(other => { if (other !== details) other.open = false; });
      }));
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const opened = event.target.closest('details[open]');
        if (opened) {
          opened.open = false;
          opened.querySelector('summary')?.focus();
          event.preventDefault();
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
